import { styled, Box, Avatar } from "@mui/material";
import { getItemHoverColor } from "../../widgets";

export const Root = styled(Box)(({ theme }) => ({
    display: "flex",
    padding: ".7em",
    alignItems: "center",
    transition: "background-color 0.3s",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: getItemHoverColor(theme),
    },
}));

export const ParticipantAvatar = styled(Avatar)({
    width: 32,
    height: 32,
    fontSize: "1em",
    transition: "box-shadow 0.2s ease-in-out",
    marginLeft: "0.5em",
});

export const AvatarSpeaking = styled(ParticipantAvatar)(({ theme }) => ({
    boxShadow: `0 0 1px 3px ${theme.palette.background.default}, 0 0 1px 5px ${theme.palette.primary.main}`,
}));

export const Text = styled(Box)({
    flexGrow: 1,
    margin: "0 .7em",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
});

export const TextSubtitle = styled(Box)({
    opacity: 0.7,
    fontSize: "0.8em",
});

export const Icon = styled(Box)({
    margin: "0.2em",
});

export const Hand = styled(Box)({
    transition: "opacity 0.2s",
});

export const Icons = styled(Box)({
    display: "flex",
    alignItems: "center",
});
